module.exports = __webpack_public_path__ + "img/SKMJ_saferoad1.2c1ff5b6.jpg";